/* Handle variant change */
const $mainSelect = $('#product-select');

$('.js-variant').on('change', function() {
  const $selectedRadios = $('.product__variant input:checked');
  const $selectedOptions = $('.product__variant option:selected');
  let selector = '';

  $selectedRadios.each(function() {
    const $radio = $(this);
    const option = $radio.closest('.product__variant').data('option');
    selector += `[data-${option}="${$radio.val()}"]`
  })

  $selectedOptions.each(function() {
    const $option = $(this);
    const option = $option.closest('.product__variant').data('option');

    selector += `[data-${option}="${$option.val()}"]`
  })

  $mainSelect.find(`option${selector}`).prop('selected', true).trigger('change')
})

$mainSelect.on('change', function() {
  const $addButton = $(this).closest('form').find('button[name="add"]')
  const $option = $(this).find('option:selected');
  const priceElement = $option.data('final_price');
  const available = !$option.attr('disabled');

  $('.js-price').html(priceElement);

  available ? $addButton.text('Add to cart').prop('disabled', false) : $addButton.text('Sold out').prop('disabled', true)
})